import ContentManagementPage from '../ContentManagement/ContentManagementPage';

const PackageContentManagementPage = () => (
  <ContentManagementPage mode="package" />
);

export default PackageContentManagementPage;
